"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _classPrivateFieldLooseBase2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classPrivateFieldLooseBase"));

var _classPrivateFieldLooseKey2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classPrivateFieldLooseKey"));

var _Base2 = _interopRequireDefault(require("./Base"));

var _route = /*#__PURE__*/(0, _classPrivateFieldLooseKey2["default"])("_route");

var _config = /*#__PURE__*/(0, _classPrivateFieldLooseKey2["default"])("_config");

var AbstractRoute = /*#__PURE__*/function (_Base) {
  (0, _inherits2["default"])(AbstractRoute, _Base);

  var _super = (0, _createSuper2["default"])(AbstractRoute);

  function AbstractRoute(route, config) {
    var _this;

    (0, _classCallCheck2["default"])(this, AbstractRoute);
    _this = _super.call(this);
    Object.defineProperty((0, _assertThisInitialized2["default"])(_this), _route, {
      writable: true,
      value: null
    });
    Object.defineProperty((0, _assertThisInitialized2["default"])(_this), _config, {
      writable: true,
      value: null
    });
    (0, _classPrivateFieldLooseBase2["default"])((0, _assertThisInitialized2["default"])(_this), _route)[_route] = route;
    (0, _classPrivateFieldLooseBase2["default"])((0, _assertThisInitialized2["default"])(_this), _config)[_config] = config;
    return _this;
  }

  (0, _createClass2["default"])(AbstractRoute, [{
    key: "config",
    get: function get() {
      if (!(0, _classPrivateFieldLooseBase2["default"])(this, _config)[_config]) {
        throw new Error('config не задан');
      }

      return (0, _classPrivateFieldLooseBase2["default"])(this, _config)[_config];
    }
  }, {
    key: "route",
    get: function get() {
      return (0, _classPrivateFieldLooseBase2["default"])(this, _route)[_route];
    }
  }, {
    key: "render",
    value: function render() {
      throw new Error('Метод "render" не переопределен');
    }
  }]);
  return AbstractRoute;
}(_Base2["default"]);

var _default = AbstractRoute;
exports["default"] = _default;